import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import cn from 'classnames';

import { Checkbox, Input, QtySelector, useValidator } from 'components';
import ProductStatusExtended from 'components/layout/ProductStatusExtended';
import ProductThumbnailImage from 'components/layout/ProductThumbnailImage';

import { productStatuses } from 'src/constants/enums';

import style from './ProductSelector.module.scss';

const ProductSelector = ({
  status,
  product,
  onSelectChange,
  disabled,
  isSelected,
  withExpireDate,
  isLoading,
  onChange,
  parentValidator
}) => {
  const { thumbnail, image, name, qty, unit_name, product_id, received_quantity, currentQuantity } = product;

  const maxQuantityToReceive = Math.max(qty - received_quantity, 0);

  const validator = useValidator();

  const [expireDateVersion, setExpireDateVersion] = useState(0);
  const [expireDate, setExpireDate] = useState();

  const onSelectChangeHandler = (isSelected) => {
    if (withExpireDate && !validator.allValid()) {
      validator.showMessages();
      return null;
    }

    onSelectChange({ ...product, expireDate, isSelected });
  };

  useEffect(() => {
    if (withExpireDate) {
      onSelectChange({ ...product, expireDate, isSelected: Boolean(expireDate) });
    }
  }, [expireDate, expireDateVersion]);

  return (
    <div
      className={cn(style.container, {
        [style.collectPart]: status === productStatuses.completed,
        [style.withExpireDate]: withExpireDate
      })}
    >
      <div className={cn(style.wrapper, style.first)}>
        <ProductThumbnailImage
          thumbnail={thumbnail}
          image={image}
          title={name}
          id={product_id}
        />
        <p className={style.text}>{name}</p>
      </div>
      {status !== productStatuses.completed && (
        <div className={style.wrapper}>
          <p>
            {qty}&nbsp;{unit_name}
          </p>
        </div>
      )}
      {withExpireDate && (
        <div className={style.wrapper}>
          <Input
            type='date'
            id='expire_date'
            name='expier_date'
            label='Data ważności produktu'
            value={expireDate || ''}
            onChange={(e) => setExpireDate(e.target.value)}
            onKeyDown={() => setExpireDateVersion((prev) => prev + 1)}
          />
        </div>
      )}
      <div className={style.wrapper}>
        <ProductStatusExtended
          product={product}
          className={style.tag}
        />
      </div>
      <div className={classNames(style.wrapper, { [style.checkboxWrapper]: status !== productStatuses.completed })}>
        {status === productStatuses.completed ? (
          <>
            <QtySelector
              wrapperStyle={style.qtySelector}
              setState={(currentQuantity) => onChange({ ...product, currentQuantity })}
              suffix={unit_name}
              state={currentQuantity}
              max={maxQuantityToReceive}
              width={120}
              rule={`not_negative|max:${maxQuantityToReceive},num`}
              validator={parentValidator}
              disabled={isLoading}
            />
            <p>
              / {maxQuantityToReceive}&nbsp;{unit_name}
            </p>
          </>
        ) : (
          <Checkbox
            value={isSelected}
            onChange={(e) => onSelectChangeHandler(e.target.checked)}
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
};

export default ProductSelector;
